(ns renolit-roofing-service.layout.form.form-item.advanced-select.fixed-choices
  (:require [medley.core :as medley]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.form.form-item.advanced-select :as form-item.advanced-select]
            [renolit-roofing-service.util :as util]))

(defmethod form.form-item/form-item-component :advanced-select-with-fixed-choices
  [_opts]
  (let [search-value (r/atom nil)]
    (fn [{:keys [state path choices choice-sort-fn
                 choice-id-kw choice-display-name-kw choice-display-fn]
          :or {choice-id-kw form-item.advanced-select/default-choice-id-kw
               choice-display-name-kw form-item.advanced-select/default-choice-display-name-kw}
          :as opts}]
      (let [selected-value (get-in @state path)
            choice-sort-fn (or choice-sort-fn #(sort-by choice-display-name-kw %))
            choice-display-fn (or choice-display-fn
                                  #(get % choice-display-name-kw))
            choices' (mapv (fn [c]
                             (assoc c choice-display-name-kw (choice-display-fn c)))
                           (or choices (:choices opts)))]
        [form.form-item/form-item-component
         (medley/deep-merge
          opts
          {:type :advanced-select
           :display-value (->
                           (medley/find-first #(= selected-value (get % choice-id-kw)) choices')
                           (get choice-display-name-kw))
           :choices (->> choices'
                         (util/filter-search-coll @search-value [choice-display-name-kw])
                         (choice-sort-fn))
           :on-search {:fn #(reset! search-value %)}
           :on-close {:fn #(reset! search-value nil)}})]))))
